module.exports = __webpack_public_path__ + "static/media/most-wanted.edf3eed0.png";